import React from "react"
import PropTypes from "prop-types"

class TextInput extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
      return(
        <div
          style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <p className="label_standard">{this.props.label}</p>
            {this.props.inputError.length > 0 && <p className="input_error">{this.props.inputError}</p>}
            <input
              onChange={(event) => this.props.onChange(event.target.value)}
              value={this.props.value}
              className="input_standard"
              placeholder={this.props.placeholder} />
        </div>
      )
  }
}

export default TextInput;


// <TextInput
//   label={}
//   value={}
//   inputError={}
//   onChange={}
//   placeholder={}
// />
